import { SxProps, Theme } from '@mui/material'

/**
 * Compact inputs for the narrow multi-edit sidebar — the same tightened padding
 * the single-element Auflagerpressung table uses for these fields. Covers both
 * the number fields and the dropdowns of the section.
 */
export const compactFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-notchedOutline': { padding: '0 4px' },
  '& input': { padding: '4px 8px' },
  '&.MuiInputBase-root .MuiSelect-select, & .MuiSelect-select': { padding: '4px 8px' },
}

/** Trims the Checkbox' default 9px hit-area padding down for the dense field blocks. */
export const compactCheckboxSx: SxProps<Theme> = { padding: '2px' }

/**
 * Sx for a `Box` wrapping one field in a row of several: the field grows to
 * share the row's full width equally with its siblings instead of sitting at
 * its own content size, down to `minPx` — below that it wraps onto its own
 * line rather than shrinking further. `minWidth: 0` lets it actually shrink
 * that far; flex items otherwise refuse to shrink below their content's
 * intrinsic width.
 *
 * This goes on a wrapping Box, not the field's own `sx` — CentimeterField's
 * `sx` targets the inner TextField, not the outer FormControl that is the
 * row's actual flex item, so sizing it there would have no visible effect.
 */
export const growFieldSx = (minPx: number): SxProps<Theme> => ({
  flex: `1 1 ${minPx}px`,
  minWidth: 0,
})

/**
 * compactFieldSx plus `width: 100%` — for the field itself inside a
 * `growFieldSx` wrapping Box. CentimeterField/UnitConvertedField otherwise
 * default to a content-sized input, which would ignore the Box's grown width
 * and leave it looking just as narrow as before.
 */
export const growFieldInnerSx: SxProps<Theme> = {
  ...compactFieldSx,
  width: '100%',
}
